module.exports = "<iframe src=\"https://dev-faq.intelcia.com/?id=1000\"\n        style=\"\n    width: 100%;\n    height: 100%;\n    border: none;\n\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/faq/faq.component.html
// module id = ./src/app/view/faq/faq.component.html
// module chunks = main